import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getPlatformCards } from '../../utils/profileUtils';
import recentActivities from '../../config/recent-activities.json';
import './QuickNav.css';

const QuickNav = () => {
  const location = useLocation();
  const platformCards = getPlatformCards();

  const quickActions = [
    { label: 'GitHub', icon: '🔗', url: 'https://github.com' },
    { label: 'LinkedIn', icon: '💼', url: 'https://linkedin.com' },
    // { label: 'Email', icon: '📧', url: 'mailto:victor@example.com' }
  ];

  const techStack = [
    'Java', 'Spring', 'React', 'Python', 'Docker'
  ];

  return (
    <aside className="quick-nav">

        <div className="platform-cards">
            <h3>Writing for:</h3>
            {platformCards.map((platform) => (
                <Link
                    key={platform.name}
                    to={platform.path}
                    className={`project-type-card ${location.pathname === platform.path ? 'active' : ''}`}
                >
                    <div className="project-type-icons">
                        <img src={platform.image} alt={platform.name} />
                    </div>
                    <span>{platform.name}</span>
                </Link>
            ))}
        </div>

        <div className="projects-cards">
            <h3>Projects:</h3>
            <Link to="/projects?type=extension" className="project-type-card">
                <div className="project-type-icons">
                    <img src="/portfolio/assets/images/chrome-logo.svg" alt="Chrome" />
                    <img src="/portfolio/assets/images/edge-logo.webp" alt="Edge" />
                </div>
                <span>Browser Extensions</span>
            </Link>
            <Link to="/projects?type=mobile" className="project-type-card">
                <div className="project-type-icons">
                    <img src="/portfolio/assets/images/android-logo.svg" alt="Android" />
                    <img src="/portfolio/assets/images/ios-logo.svg" alt="iOS" />
                </div>
                <span>Mobile Apps</span>
            </Link>
        </div>

        <div className="activity-feed">
            <h3>Recent Activity</h3>
            {recentActivities.map((activity) => (
                <Link key={activity.id} to={activity.link} className="activity-item" title={activity.tags.join(', ')}>
                    <span className="activity-dot"></span>
                    <div>
                        <p>{activity.activity}</p>
                        <span className="activity-time">
                            {new Date(activity.timestamp).toLocaleDateString()}
                        </span>
                    </div>
                </Link>
            ))}
        </div>

    </aside>
  );
};

export default QuickNav;
